module.exports = {
  name: 'ConsoleNotifier',
  data() {
    return {
      console: true
    }
  },
  methods: {
    gotoConsole() {
      this.console = false;
      window.open('https://console.luffanet.com.tw', '_blank');
    }
  },
  template: `
<v-snackbar v-model="console" right bottom :timeout="10000">
  Luffanet Console has been announced.
  <v-btn flat dark color="blue" @click="gotoConsole">Try it</v-btn>
</v-snackbar>
  `
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/ConsoleNotifier.js
// module id = 5Tf/
// module chunks = 0